import { useContext } from 'react'

import Grid from '@mui/material/Grid'

import { ROLE_LEVEL } from 'constants/roles'
import { useAuth } from 'context/auth'
import Customer from 'layouts/feedback/internal/components/Customer'
import CustomerOutcome from 'layouts/feedback/internal/components/CustomerOutcome'
import Details from 'layouts/feedback/internal/components/Details'
import Investigation from 'layouts/feedback/internal/components/Investigation'
import MemberOutcome from 'layouts/feedback/internal/components/MemberOutcome'
import { FormContext } from 'layouts/feedback/internal/constants'

function ComplaintForm() {
	const { user } = useAuth()
	const formContext = useContext(FormContext)
	const { isNew } = formContext
	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Details />
			</Grid>
			<Grid item xs={12}>
				<Customer />
			</Grid>
			{!isNew && ROLE_LEVEL[4].includes(user.data.role) && (
				<>
					<Grid item xs={12}>
						<Investigation />
					</Grid>
					<Grid item xs={12}>
						<MemberOutcome />
					</Grid>
					<Grid item xs={12}>
						<CustomerOutcome />
					</Grid>
				</>
			)}
		</Grid>
	)
}

export default ComplaintForm
